import { ZDataNode } from "../types/dataTypes";

export const ex1data = [
  {
    name: "actual",
    type: "bool",
    value: true,
  },
  {
    name: "fullName",
    type: "string",
    value: "МОЯ ЦЕНА Продукт плав с сыр Дружба 50% 70г фольга",
  },
  {
    // Единица измерения (кг/ литры/ упк) - позже заменить на Options
    name: "units",
    type: "strOption",
    value: { label: "упк", value: "pack" },
  },
  {
    name: "unitMass",
    type: "number",
    value: 70,
  },
  {
    name: "contracts",
    type: "recordArray",
    value: [
      [
        { name: "contractType", type: "string", value: "ГК" },
        { name: "number", type: "string", value: "890337" },
        { name: "fullName", type: "string", value: "ГК/890337/14" },
        {
          name: "terms",
          type: "recordArray",
          value: [[{ name: "field1", type: "string", value: "string-1" }]],
        },
      ],
      [
        { name: "contractType", type: "string", value: "ABC" },
        { name: "number", type: "string", value: "12345" },
        { name: "fullName", type: "string", value: "ABC/12345/314" },
      ],
    ],
  },
] satisfies ZDataNode[];
